import React from 'react';
import replaceCommaWithDot from '../../../helpers/utils/replaceCommaWithDot';
import { plural } from 'utils/plural';
import EstimationBlock from '../templates/common/estimationBlock';
import SliderControllerBlock from '../templates/common/sliderControllerBlock';
import { pluralDaysAfterTo } from '../../../helpers/utils/pluralDaysAfterTo';

export default function template(context) {
    const calc = context.calc,
      model = calc.state.model,
      phraseArray = ['CALCULATOR_FULL_PAYMENTS_02', 'CALCULATOR_FULL_PAYMENTS_01','CALCULATOR_FULL_PAYMENTS'],
      termBtns = (
        <>
          {model.getTerms().map((item, index) => {
            return (
              <button 
                className={`controllers-calculator-new__btn controllers-calculator-new__btn_${index + 1} ${+item === Number(model.getCreditTerm()) ? 'active' : ''}`} 
                name="loanTerm" 
                key={item} 
                onClick={calc.handleChange} 
                value={index}
              >
                {item}  {calc.l10n(`${plural(item, phraseArray )}`)}
              </button>
            )
          })}
        </>
      );

  const estimationData = [
    {
      label: calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW'),
      value: `${replaceCommaWithDot(model.getRequiredPayment().toLocaleString())} ${calc.l10n('UAH_ICON')}`
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN'),
      value: `${model.getCreditSum().toLocaleString()} ${calc.l10n('UAH_ICON')}`
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_PAYMENTS'),
      value: `${model.getCreditTerm()} ${calc.l10n(`${plural(model.getCreditTerm(), phraseArray)}`)}`
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_LOAN_TERM_LABEL_NEW_DESIGN'),
      value: model.getMaxDays()
        ? `${calc.l10n('CALCULATOR_NEW_INSTALLMENT_FROM_STATEMENT_PAYMENT_TERM_TILL')} ${model.getMaxDays()} ${calc.l10n(pluralDaysAfterTo(model.getMaxDays()))}`
        : null
    },
    {
      label: calc.l10n('CALCULATOR_NEW_REAL_PERCENT_RATE'),
      value: `${replaceCommaWithDot(model.getRealRate())}${calc.l10n('CALCULATOR_CREDIT_PERCENT')}`
    },
    {
      label: calc.l10n('CALCULATOR_OVERPAYMENT'),
      value: `${replaceCommaWithDot(model.getOverpayment().toLocaleString())} ${calc.l10n('UAH_ICON')}`
    },
    {
      label: calc.l10n('CALCULATOR_TOTAL_COST'),
      value: `${replaceCommaWithDot(model.getCreditCost().toLocaleString())} ${calc.l10n('UAH_ICON')}`
    }
  ];


  return (
    <div className="calculator-new__content">
      <div className="calculator-new__top top-calculator-new">
        <div className="top-calculator-new__body">
          <h2 className="top-calculator-new__title">{calc.l10n('CALCULATOR_NEW_TITLE')}</h2>
          <div className="top-calculator-new__base-rate">
            {calc.l10n("CALCULATOR_NEW_INSTALLMENT_FROM_STATEMENT_BASE_RATE")} <span>{model.getCreditRate() + calc.l10n("PERCENT")}</span>
          </div>
        </div>
      </div>
      <div className="calculator-new__bottom">
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_SUM_CONTROLLERS_TITLE')}
          inputName="creditSum"
          value={model.getCreditSum()}
          currency={calc.l10n('UAH_ICON')}
          min={model.getMinSumEdge()}
          max={model.getMaxSumEdge()}
          step={model.getSumStep()}
          currencyOffset={calc.state.valueWith}
          hiddenValueRef={calc.hiddenValue}
          onInputChange={calc.handleChangeInput}
          onInputBlur={calc.blurChangeInput}
          onRangeChange={calc.handleChange1}
          showError={calc.state.error}
          errorText={`${calc.l10n('CALCULATOR_CREDIT_ERROR_TEXT')} ${model.getMinSumEdge()} ${calc.l10n('UAH_ICON')}`}
        />
        <div className="calculator-new__controllers controllers-calculator-new">
          <div className="controllers-calculator-new__title">
            {calc.l10n('CALCULATOR_CREDIT_PAYMENTS')}
          </div>
          <div className={`controllers-calculator-new__row controllers-calculator-new__row_${model.getTerms().length}`}>
            {termBtns}
          </div>
        </div>  
        <EstimationBlock
          title={calc.l10n('CALCULATOR_NEW_ESTIMATION_TITLE')}
          items={estimationData}
        />
      </div>
    </div>
  );
}
